import { render } from "./TranslationEngine.vue?vue&type=template&id=f99e8560"
import script from "./TranslationEngine.vue?vue&type=script&setup=true&lang=js"
export * from "./TranslationEngine.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Captioning/TranslationEngine.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f99e8560"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f99e8560', __exports__)) {
    api.reload('f99e8560', __exports__)
  }
  
  module.hot.accept("./TranslationEngine.vue?vue&type=template&id=f99e8560", () => {
    api.rerender('f99e8560', render)
  })

}


export default __exports__